import * as _ from "lodash";
import DataGenerator from "../DataGenerator";
import {INodeModel} from "@/shared/models/abstract/INodeModel";
import {EntityType} from "@/shared/models/entityType";
import {uuid} from "uuidv4";
import faker from "faker";
import NodeBaseModel from "@/shared/models/abstract/nodeBaseModel";

export default class ReminderModel extends NodeBaseModel {


    private _importance: number;


    get importance() {
        return this._importance;
    }

    set importance(value) {
        if(value>5 || value<1){
            throw new Error("The importance of a reminder should be a number between 1 and 5.");
        }
        this._importance = value;
        this.raisePropertyChanged("importance");
    }


    constructor() {
        super(EntityType.Reminder, "REMINDER");
        this._importance = 1;
    }


    static fromJson(json) {
        if (json.entityType !== EntityType.Reminder) {
            throw new Error("Wrong deserialization data.");
        }
        let m = new ReminderModel();
        m = _.assign(m, json);
        return m;
    }

    toJson() {
        const m = super.toJson();

        m.importance = this.importance;
        return m;
    }

    clone() {
        const clone = ReminderModel.fromJson(this.toJson());
        clone.id = DataGenerator.id();
        return clone;
    }
};
